const ORDER = 'Order';
const ITEM = 'Item';
const AUTH = 'Auth';
const CATEGORY = 'Category';
const CUSTOMERS = 'Customers';
const RECIPE = 'Recipe';
const RECIPES = 'Recipes';
const USER = 'User';
const FILLING = 'Filling';
const FILLINGS = 'Fillings';
const RECIPES_LIGHT = 'RecipesLight';
const RECIPES_FOR_ORDER = 'RecipesForOrder';
const UNREVIEWED_ORDERS = 'UnreviewedOrders';
// TODO: need to use core types and later add id e.g. { type: 'Order', id: 'search' }
export const tagTypes = [ORDER, ITEM, AUTH, CATEGORY, CUSTOMERS, RECIPE, RECIPES, USER, FILLING, FILLINGS, RECIPES_LIGHT, RECIPES_FOR_ORDER, UNREVIEWED_ORDERS];
